module.exports = "<div class=\"ui button mini {{getWorkTypeButtonColor(work_type_id)}}\" *ngFor=\"let work_type_id of projectSvc.checkedsWorkTypeIds\" \n    (click)=\"workSvc.onFilterWorkType(work_type_id)\">\n    {{workTypeSvc.getItemById(work_type_id).title}}\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/component/work/header/buttons/work-header-buttons.cmp.html
 ** module id = 398
 ** module chunks = 0
 **/